/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Email_Task_Assigned_Intro_FallbackInputs */

const en_email_task_assigned_intro_fallback = /** @type {(inputs: Email_Task_Assigned_Intro_FallbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The task "${i?.task}" was assigned to you.`)
};

const pt_br2_email_task_assigned_intro_fallback = /** @type {(inputs: Email_Task_Assigned_Intro_FallbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A atividade "${i?.task}" foi atribuída a você.`)
};

/**
* | output |
* | --- |
* | "The task \"{task}\" was assigned to you." |
*
* @param {Email_Task_Assigned_Intro_FallbackInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_intro_fallback = /** @type {((inputs: Email_Task_Assigned_Intro_FallbackInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_Intro_FallbackInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_intro_fallback(inputs)
	return pt_br2_email_task_assigned_intro_fallback(inputs)
});